import { SxProps, Theme } from '@mui/material/styles';

const dashboardHoverSx = {
  transition: 'transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease, background-color 180ms ease',
  '@media (hover: hover) and (pointer: fine)': {
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 10px 24px rgba(44, 42, 41, 0.08)',
      borderColor: 'rgba(1, 110, 195, 0.18)',
    },
  },
  '@media (prefers-reduced-motion: reduce)': {
    transition: 'none',
    '&:hover': {
      transform: 'none',
    },
  },
} as const;

export const dashboardStatCardSx: SxProps<Theme> = {
  ...dashboardHoverSx,
  overflow: 'hidden',
};

export const dashboardActionAreaSx: SxProps<Theme> = {
  height: '100%',
  borderRadius: 'inherit',
  overflow: 'hidden',
  transition: 'background-color 180ms ease',
  '&:focus-visible': {
    outline: '3px solid',
    outlineColor: 'primary.light',
    outlineOffset: '-3px',
  },
  '@media (hover: hover) and (pointer: fine)': {
    '&:hover': {
      backgroundColor: 'rgba(1, 110, 195, 0.025)',
    },
  },
};

export const dashboardListRowSx: SxProps<Theme> = {
  transition: 'background-color 180ms ease',
  px: 1.5,
  mx: -1.5,
  borderRadius: 1.5,
  cursor: 'pointer',
  '@media (hover: hover) and (pointer: fine)': {
    '&:hover': {
      bgcolor: 'action.hover',
    },
  },
  '@media (prefers-reduced-motion: reduce)': {
    transition: 'none',
  },
  '&:focus-visible': {
    outline: '2px solid',
    outlineColor: 'primary.main',
    outlineOffset: 2,
  },
};
